module.exports = __webpack_public_path__ + "static/media/1.fbf35346.jpg";